import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DeprecatedSharedUtilsModule} from '../../../../deprecated-shared-utils-module';

interface FilterItem {
    value: string;
    label: string;
}

@Component({
    selector: 'ui-switch-manager',
    templateUrl: './ui-switch-manager.component.html',
    styleUrls: ['./ui-switch-manager.component.scss'],
    standalone: false,
})
export class UiSwitchManagerComponent {

    @Input() label: string = '';
    @Input() selectedItem: string = '';
    @Input() items: FilterItem[] | { [key: string]: FilterItem } = [];
    @Output() selectItem = new EventEmitter<string>();
    @Input() margin: string = '15px 15px 0px 15px';

    constructor(
        private cdr: ChangeDetectorRef
    ) {
    }

    onSelectItem(value: string): void {
        if (value !== this.selectedItem) {
            this.selectedItem = value;
        } else {
            this.selectedItem = '';
        }
        this.selectItem.emit(this.selectedItem);
        this.cdr.detectChanges();
    }

    get itemsArray(): FilterItem[] {
        if (Array.isArray(this.items)) {
            return this.items;
        } else if (typeof this.items === 'object') {
            return Object.values(this.items);
        }
        return [];
    }
}
